export const userReview = [
  {
    name: 'Martín Pasternak',
    avatarImage: '/images/Review_Martin_Pasternak.png',
    review: 'landing.footer.reviews.user1'
  },
  {
    name: 'Fernanda Di Benedetto',
    avatarImage: '/images/Review_Fernanda_Di_Benedetto.png',
    review: 'landing.footer.reviews.user2'
  },
  {
    name: 'Facundo Ortega',
    avatarImage: '/images/Review_Facundo_Ortega.png',
    review: 'landing.footer.reviews.user3'
  },
  {
    name: 'Zu Quiroz',
    avatarImage: '/images/Review_Zu_Quiroz.png',
    review: 'landing.footer.reviews.user4'
  },
  {
    name: 'Jose Ignacio Argañaraz',
    avatarImage: '/images/Review_Jose_Ignacio_Arganaraz.png',
    review: 'landing.footer.reviews.user5'
  }
];

export const userReviewCityLanding = [
  {
    name: 'Martín Pasternak',
    avatarImage: '/images/Review_Martin_Pasternak.png',
    review: 'testimonial-description-1'
  },
  {
    name: 'Fernanda Di Benedetto',
    avatarImage: '/images/Review_Fernanda_Di_Benedetto.png',
    review: 'testimonial-description-2'
  },
  {
    name: 'Facundo Ortega',
    avatarImage: '/images/Review_Facundo_Ortega.png',
    review: 'testimonial-description-3'
  },
  {
    name: 'Zu Quiroz',
    avatarImage: '/images/Review_Zu_Quiroz.png',
    review: 'testimonial-description-4'
  },
  {
    name: 'Jose Ignacio Argañaraz',
    avatarImage: '/images/Review_Jose_Ignacio_Arganaraz.png',
    review: 'testimonial-description-5'
  }
];

export const footerLinks = {
  aboutUs: {
    mainText: 'about-us.title',
    links: [
      {
        label: 'about-us.link-1',
        url: 'https://blog.rentennials.app/'
      },
      {
        label: 'about-us.link-2',
        url: 'https://blog.rentennials.app/faqs/'
      },
      {
        label: 'about-us.link-3',
        url: 'https://blog.rentennials.app/como-alquilar-tus-vehiculos/'
      },
      {
        label: 'about-us.link-4',
        url: 'https://blog.rentennials.app/destinos/'
      },
      {
        label: 'about-us.link-6',
        url: 'https://blog.rentennials.app/blog/'
      },
      {
        label: 'about-us.link-7',
        url: 'https://corporativo.rentennials.app/'
      }
    ]
  },
  locations: {
    mainText: 'locations.title',
    links: []
  },
  enterprise: {
    mainText: 'enterprise.title',
    links: [
      {
        label: 'enterprise.link-1',
        url: 'https://blog.rentennials.app/terminos-y-condiciones/'
      },
      {
        label: 'enterprise.link-2',
        url: 'https://blog.rentennials.app/politicas-de-privacidad/'
      },
      {
        label: 'enterprise.link-3',
        url: 'https://blog.rentennials.app/partners/'
      },
      {
        label: 'enterprise.link-4',
        url: 'https://blog.rentennials.app/contacto/'
      }
    ]
  }
};
